import { gql } from "@apollo/client";

export const AGENT_LOGIN = gql`
  mutation ($request: String!) {
    userLogin(userLoginRequest: $request) {
      messageDescription
      responseData {
        id
        isfirsttimeuser
        isOtpRequired
        refreshToken
        token
      }
      successTypeCode
      failedTypeCode
    }
  }
`;
export const AGENT_Refresh_Token = gql`
  mutation RefreshToken(
    $accessToken: String!
    $hierarchy: String!
    $refreshToken: String!
    $userId: UUID!
  ) {
    refreshToken(
      request: {
        accessToken: $accessToken
        hierarchy: $hierarchy
        refreshToken: $refreshToken
        userId: $userId
      }
    ) {
      correlationId
      messageCode
      messageDescription
      successTypeCode
      responseData {
        token
        refreshToken
      }
    }
  }
`;

export const AGENT_SIGNUP = gql`
  mutation AddBookingAgent($registrationAgentVM: RegistrationAgentVMInput!) {
    agentRegistration(registrationAgentVM: $registrationAgentVM) {
      correlationId
      successTypeCode
      messageDescription
      messageCode
      responseData {
        id
      }
    }
  }
`;

export const AGENT_CONTACT_DETAILS = gql`
  mutation AddUpdateAgentContacts($agentcontactsVM: AgentContactsVMInput!) {
    addUpdateAgentContacts(agentcontactsVM: $agentcontactsVM) {
      correlationId
      successTypeCode
      messageDescription
      messageCode
      responseData {
        agent_id
        agentContactsInfo {
          contacttype
          designation
          email
          id
          name
          phone
        }
      }
    }
  }
`;

export const GST_STATE_CODE = gql`
  query ($request: GSTStateCodesFilterVMInput!) {
    gstStateCodes(filter: $request) {
      responseData {
        gst_state_code
        state_name
      }
      successTypeCode
    }
  }
`;

export const COUNTRIES_CODE = gql`
  query {
    countries {
      correlationId
      messageCode
      messageDescription
      successTypeCode
      totalRecords
      responseData {
        country
        countrycode2
        countrycode3
        currency_code
        id
        phone_code
        time_zones
      }
    }
  }
`;

export const STATES_CODE = gql`
  query CitiesQuery($name: String) {
    cities(name: $name) {
      correlationId
      messageCode
      messageDescription
      successTypeCode
      totalRecords
      responseData {
        country_code
        country_id
        description
        id
        is_active
        name
      }
    }
  }
`;
export const CURRENCY_LIST = gql`
  query {
    currencies {
      correlationId
      messageCode
      messageDescription
      successTypeCode
      totalRecords
      responseData {
        description
        name
        is_active
        id
      }
    }
  }
`;

export const AGENT_PROFILE_INFO = gql`
  query {
    agentProfile {
      messageCode
      messageDescription
      successTypeCode
      responseData
    }
  }
`;

export const AGENT_FORGOT_PASSWORD = gql`
  mutation ForgetPassword($request: String!) {
    forgetPassword(resetData: $request) {
      messageDescription
      responseData
      successTypeCode
    }
  }
`;

export const AGENT_RESET_PASSWORD = gql`
  mutation ($request: String!) {
    resetPassword(request: $request) {
      successTypeCode
      responseData
      messageDescription
    }
  }
`;

export const AGENT_RESET_PASSWORD_LINK_STATUS = gql`
  mutation ($request: String!) {
    resetPwdLinkExpiredStatus(request: $request) {
      successTypeCode
      responseData
      messageDescription
    }
  }
`;

export const RESEND_OTP = gql`
  mutation ResendOTP($request: String!) {
    resendOTP(request: $request) {
      responseData
      successTypeCode
      messageDescription
    }
  }
`;

export const VERIFY_OTP = gql`
  mutation VerifyOTP($request: String!) {
    verifyOTP(request: $request) {
      correlationId
      messageCode
      messageDescription
      successTypeCode
      totalRecords
      responseData {
        id
        isfirsttimeuser
        isOtpRequired
        refreshToken
        token
      }
    }
  }
`;

export const CHANGE_PASSWORD = gql`
  mutation ChangePassword($request: String!) {
    changePassword(request: $request) {
      messageDescription
      responseData
    }
  }
`;

export const GENERATE_LOGINURL = gql`
  query LoginUrl($isLocal: Boolean) {
    loginUrl(isLocal: $isLocal)
  }
`;

export const GENERATE_NONLOCAL_LOGINURL = gql`
  query LoginUrl {
    loginUrl
  }
`;

export const GENERATE_ACCESS_TOKEN_QUERY = gql`
  query GenerateAccessToken($code: String!) {
    generateAccessToken(code: $code)
  }
`;
